import {
  ENDPOINT_CARTS,
  ENDPOINT_ITEMS,
  ENDPOINT_QUOTES,
  ENDPOINT_ROOT,
  ENDPOINT_WISHLISTS,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

/**
 * Delete item from target given with his type
 * @param {object} item
 * @param {object} target
 * @param {string} type
 * @returns {Promise<AxiosResponse<any>>}
 */
const deleteTypeItem = ({ item, target, type }) => {
  // Used to get the endpoint dynamically
  const endpoints = {
    ENDPOINT_CARTS,
    ENDPOINT_WISHLISTS,
    ENDPOINT_QUOTES,
    ENDPOINT_ROOT,
    ENDPOINT_ITEMS,
  };

  // Get the endpoint depends on type
  const typeEndpoint = `ENDPOINT_${type.toUpperCase()}`;

  return axiosAuth
    .delete(
      `${ENDPOINT_ROOT}/${endpoints[typeEndpoint]}/${target.id}/${ENDPOINT_ITEMS}/${item.id}`,
    )
    .then((res) => res);
};

export default deleteTypeItem;
